import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal, toggleModalWithTimer, toggleSpinner } from 'apps/auth/actions/appAction';
import { setExtra } from 'apps/auth/actions/extraAction';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { NEW_ACCOUNT_ADDED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { ACCOUNT_CURRENCY } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { apiFetchData } from 'apps/auth/helpers/api';

const PanelForAddNewAccount = (props) => {
    const doRequest = (e, url) => {
        e.preventDefault();
        props.toggleSpinner(true);
        apiFetchData(url)
            .then((json) => {
                if (json) {
                    if (json.extra) {
                        props.setExtra(json.extra);
                    }
                }
                props.toggleModal(false);
                props.toggleModalWithTimer(true, props.accountAddedScreen);
                props.toggleSpinner(false);
                amplitude.getInstance().logEvent(NEW_ACCOUNT_ADDED, {
                    [ACCOUNT_CURRENCY]: props.account.code,
                });
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    const account = props.account;

    const code = account.code;

    return (
        <Row indent="adaptive-24-32">
            <Panel
                isBordered
                hasBorderRadius
                isHoverable
                onClick={(e) => {
                    doRequest(e, `/auth/ga/add/account/${code.toLowerCase()}`);
                }}
            >
                <PanelRow>
                    <PanelRow alignStart>
                        <IconWrapper>
                            <DiskBadge src={props.getCurrencyIcon(code.toLowerCase())} alt={code.toLowerCase()} onError={props.onError} />
                        </IconWrapper>
                        {account.title}
                    </PanelRow>
                    <PanelRightBlock>
                        <Text color="secondary" smallCaps>
                            {code.toUpperCase()}
                        </Text>
                    </PanelRightBlock>
                </PanelRow>
            </Panel>
        </Row>
    );
};

const mapStateToProps = (state) => {
    return {
        accountAddedScreen: state.messages.pageMessages.accountAddedScreen,
    };
};
export default connect(mapStateToProps, { toggleModal, toggleSpinner, setExtra, toggleModalWithTimer })(PanelForAddNewAccount);
